import Axios from 'axios';
import { TableState } from './PokerTable';
import getConfig from './config';

const config = getConfig();

const apiServer = Axios.create({
  withCredentials: true,
  baseURL: config.apiServerBase,
  timeout: 5 * 1000, // seconds
});

export async function newTable() {
  const { data } = await apiServer.get(`/newTable`);
  return data;
}

export async function joinTable(tableId: string) {
  const { data } = await apiServer.get(`/joinTable?tableId=${tableId}`);
  return data;
}

export async function tableState(): Promise<TableState> {
  const { data } = await apiServer.get(`/tableState`);
  return data;
}

export async function sitDown(
  seatIndex: number,
  name: string,
  chips: number,
): Promise<TableState> {
  const { data } = await apiServer.get(
    `/sitDown?seatIndex=${seatIndex}&name=${name}&chips=${chips}`,
  );
  return data;
}

export async function standUp(): Promise<TableState> {
  const { data } = await apiServer.get(`/standUp`);
  return data;
}

export async function kickPlayer(seatIndex: number): Promise<TableState> {
  const { data } = await apiServer.get(`/kickPlayer?seatIndex=${seatIndex}`);
  return data;
}

export async function setDealerSeatIndex(seatIndex: number) {
  const { data } = await apiServer.get(
    `/setDealerSeatIndex?dealerSeatIndex=${seatIndex}`,
  );
  return data;
}

export async function newRound() {
  const { data } = await apiServer.get('/newRound');
  return data;
}

export async function resetRound() {
  const { data } = await apiServer.get('/resetRound');
  return data;
}

export async function showFlop() {
  const { data } = await apiServer.get('/showFlop');
  return data;
}

export async function showTurn() {
  const { data } = await apiServer.get('/showTurn');
  return data;
}

export async function showRiver() {
  const { data } = await apiServer.get('/showRiver');
  return data;
}

export async function givePotTo(seatIndex: number, amount: number) {
  const { data } = await apiServer.get(
    `/givePotTo?seatIndex=${seatIndex}&amount=${amount}`,
  );
  return data;
}

export async function bet(amount: number) {
  const { data } = await apiServer.get(`/bet?amount=${amount}`);
  return data;
}

export async function showHand() {
  const { data } = await apiServer.get('/showHand');
  return data;
}

export async function foldHand() {
  const { data } = await apiServer.get('/foldHand');
  return data;
}
